import SceneObject from "../../../lib/services/scene/sceneobject";
import ShaderService from "../../../lib/services/shader/shader_service";
import  BlobShadowRenderPipeline  from "../render/pipelines/blobshadow_renderpipeline";
import Camera from "../../../lib/services/scene/camera";
import ResourceService from "../../../lib/services/resource/resourceservice";

export default class BlobShadow extends SceneObject 
{
  shadow_renderpipeline: BlobShadowRenderPipeline;
  scale:number;
  constructor(key: string, scale: number) 
  {
    super(key);
    this.scale = scale;
    this.shadow_renderpipeline = new BlobShadowRenderPipeline("shadow","blob_shadow",1,1);
  }

  async build(device: GPUDevice, format: GPUTextureFormat, shader_service: ShaderService,resource_service: ResourceService): Promise<void> 
  {

      await this.shadow_renderpipeline.build(device,format,shader_service,resource_service);
      this.transform.set_position(0, 0.001, 0);
      this.transform.set_rotation(0, 0, 0);

      this.transform.set_scale(this.scale, this.scale, this.scale);
      this.transform.update_matrix();
  }

    private update_shadow_height_(y: number): void 
  {
      const max_height = 2.5; // typical apex above ground
      // Normalized 0..1, clamped
      const h = Math.min(Math.max(y / max_height, 0), 1);
      // Scale grows with height, peaks ~1.6x at apex
      const scale = 1.0 + h * 0.6; //needs to be relative to this.scale
      // Opacity falls with height, near-full at ground, faint at apex
      const opacity = 1.0 - h * 0.7;
      this.transform.set_scale(scale,scale,scale);
       //i dont have an opactity setting yet
      // this.shadow.set_opacity(opacity);
       this.transform.update_matrix();
}


  update_shadow(x:number,y:number,z:number)
  {
     //parent position , todo adjust scale for height off ground
      this.transform.set_position(x, 0.001, z);
      this.transform.update_matrix();
  }

  tick(delta_time: number): void 
  {
    
  }

  prepare(device: GPUDevice, camera: Camera): void 
  {
     this.shadow_renderpipeline.prepare(device,camera,this.transform);
  }

  draw(pass: GPURenderPassEncoder): void 
  {
    this.shadow_renderpipeline.draw(pass);
  }
}